import { render } from "./confirmAgence.vue?vue&type=template&id=53c9d8e6&scoped=true"
import script from "./confirmAgence.vue?vue&type=script&lang=js"
export * from "./confirmAgence.vue?vue&type=script&lang=js"

import "./confirmAgence.vue?vue&type=style&index=0&id=53c9d8e6&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c9d8e6"]])

export default __exports__